import React from 'react';
import { Flex, Spacer, Box, Divider, Stack } from '@chakra-ui/react';
import BEBadge from '@molecules/BEBadge';

const DemoBadges = () => {
  return (
    <Box>
      <h2>Badges</h2>
      <Divider m={2} />
      <Flex align={'center'} gap="12px">
        <p>Accommondation Badge</p>
        <Spacer />
        <Stack position="relative">
          <BEBadge attached={false}>Test 1</BEBadge>
          <BEBadge variant="error" attached={false}>
            Test 2
          </BEBadge>
          <BEBadge variant="warning" attached={false}>
            Test 3
          </BEBadge>
        </Stack>
      </Flex>
    </Box>
  );
};

export default DemoBadges;
